import {data} from './data';

export const howDoWeDoIt = {
	data,
	title: 'How do we do it',
};
